import { StoryGallery } from "@/components/site/StoryGallery";
import { Link, useParams } from "react-router-dom";
import { POLICIES, STORY_FULL } from "@/content/texts";
import { useCatalog, useSeo, waLink } from "@/lib/site";

export function StoryPage() {
  useSeo({ title: "Nuestra historia | LUMINA STUDIO", description: "LUMINA STUDIO nació para dar un lugar especial a nuestras fotografías. Láminas decorativas personalizadas desde Garzón, Huila, Colombia." });
  return (
    <div className="mx-auto max-w-[1300px] px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
      <div className="max-w-3xl">
        <h1 className="font-serif-display text-[34px] sm:text-[52px] font-medium leading-tight">Nuestra historia</h1>
        <p data-testid="story-full-text" className="mt-8 text-base sm:text-lg leading-[1.75] text-[#080808]/80">{STORY_FULL}</p>
      </div>
      <div className="mt-14"><StoryGallery testId="story-page-gallery" /></div>
    </div>
  );
}

export function PolicyPage() {
  const { slug } = useParams();
  const pol = POLICIES[slug];
  const { data } = useCatalog();
  useSeo({ title: `${pol?.title || "Página no encontrada"} | LUMINA STUDIO`, description: "Políticas de LUMINA STUDIO.", noindex: !pol });
  if (!pol) return <NotFoundPage />;
  return (
    <div className="mx-auto max-w-3xl px-5 sm:px-8 py-16 sm:py-24">
      <h1 data-testid="policy-title" className="font-serif-display text-[34px] sm:text-[48px] font-medium leading-tight">{pol.title}</h1>
      {pol.known && <p className="mt-8 text-base leading-[1.7]">{pol.known}</p>}
      <p data-testid="policy-pending" className="mt-8 text-base leading-[1.7] text-[#080808]/75">
        Este documento está en preparación y se publicará antes de habilitar las compras en línea. Si tienes alguna duda, escríbenos.
      </p>
      {data && <a href={waLink(data.contact.whatsapp)} target="_blank" rel="noopener noreferrer" className="mt-6 inline-block text-sm font-semibold uppercase tracking-[0.12em] underline underline-offset-4">WhatsApp {data.contact.whatsapp}</a>}
    </div>
  );
}

const ComingSoon = ({ title, testId, children }) => {
  const { data } = useCatalog();
  return (
    <div data-testid={testId} className="mx-auto max-w-2xl px-5 sm:px-8 py-20 sm:py-28 text-center">
      <h1 className="font-serif-display text-[34px] sm:text-[48px] font-medium leading-tight">{title}</h1>
      <div className="mt-6 text-base leading-[1.7] text-[#080808]/75">{children}</div>
      <div className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
        <Link to="/productos" className="rounded-full bg-[#080808] px-7 py-3.5 text-[0.75rem] font-semibold uppercase tracking-[0.16em] text-[#FAF8F4] hover:bg-[#B18A4B] transition-colors">Ver productos</Link>
        {data && <a href={waLink(data.contact.whatsapp)} target="_blank" rel="noopener noreferrer" className="rounded-full border border-[#080808] px-7 py-3.5 text-[0.75rem] font-semibold uppercase tracking-[0.16em] hover:bg-[#080808] hover:text-[#FAF8F4] transition-colors">Escríbenos por WhatsApp</a>}
      </div>
    </div>
  );
};

export function NotFoundPage() {
  useSeo({ title: "Página no encontrada | LUMINA STUDIO", noindex: true });
  return <ComingSoon title="Página no encontrada" testId="not-found-page"><p>La página que buscas no existe.</p></ComingSoon>;
}
